import React from 'react';

const viBaselineAudio = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M10.5 18V6C10.5 5.06812 10.5 4.60218 10.3478 4.23463C10.1448 3.74458 9.75542 3.35523 9.26537 3.15224C8.89782 3 8.43188 3 7.5 3C6.56812 3 6.10218 3 5.73463 3.15224C5.24458 3.35523 4.85523 3.74458 4.65224 4.23463C4.5 4.60218 4.5 5.06812 4.5 6V18C4.5 18.9319 4.5 19.3978 4.65224 19.7654C4.85523 20.2554 5.24458 20.6448 5.73463 20.8478C6.10218 21 6.56812 21 7.5 21C8.43188 21 8.89782 21 9.26537 20.8478C9.75542 20.6448 10.1448 20.2554 10.3478 19.7654C10.5 19.3978 10.5 18.9319 10.5 18Z" />
      {/* eslint-disable-next-line max-len */}
      <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M20.5 18V10C20.5 9.06812 20.5 8.60218 20.3478 8.23463C20.1448 7.74458 19.7554 7.35523 19.2654 7.15224C18.8978 7 18.4319 7 17.5 7C16.5681 7 16.1022 7 15.7346 7.15224C15.2446 7.35523 14.8552 7.74458 14.6522 8.23463C14.5 8.60218 14.5 9.06812 14.5 10V18C14.5 18.9319 14.5 19.3978 14.6522 19.7654C14.8552 20.2554 15.2446 20.6448 15.7346 20.8478C16.1022 21 16.5681 21 17.5 21C18.4319 21 18.8978 21 19.2654 20.8478C19.7554 20.6448 20.1448 20.2554 20.3478 19.7654C20.5 19.3978 20.5 18.9319 20.5 18Z" />
    </g>
  </svg>
);

export default viBaselineAudio;
